import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SimpleBar from 'simplebar-react';

//Import components
import SidebarContent from './SidebarContent';
import TwoColumnLayout from '../TwoColumnLayout';
import { Container } from 'reactstrap';
import HorizontalLayout from '../HorizontalLayout';

const Sidebar = ({ layoutType }) => {
  const tokenStorageSideBar = '@sidebarHover';

  const verifySizeSaved = () => {
    if (localStorage.getItem(tokenStorageSideBar)) {
      if (localStorage.getItem(tokenStorageSideBar) === 'true') {
        document.documentElement.setAttribute(
          'data-sidebar-size',
          'sm-hover-active'
        );
      } else {
        document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
      }
    }
  };

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName('vertical-overlay');
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener('click', function () {
        document.body.classList.remove('vertical-sidebar-enable');
      });
    }
    verifySizeSaved();
  });

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (
      document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover'
    ) {
      localStorage.setItem(tokenStorageSideBar, 'true');
      document.documentElement.setAttribute(
        'data-sidebar-size',
        'sm-hover-active'
      );
    } else if (
      document.documentElement.getAttribute('data-sidebar-size') ===
      'sm-hover-active'
    ) {
      localStorage.setItem(tokenStorageSideBar, 'false');
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      localStorage.setItem(tokenStorageSideBar, 'true');
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };
  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={process.env.REACT_APP_LOGO_SM} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={process.env.REACT_APP_LOGO_DARK} alt="" height="17" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={process.env.REACT_APP_LOGO_SM} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={process.env.REACT_APP_LOGO_LIGHT} alt="" height="17" />
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        {layoutType === 'horizontal' ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
          <TwoColumnLayout />
        ) : (
          <SimpleBar id="scrollbar" className="h-100">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <SidebarContent layoutType={layoutType} />
              </ul>
            </Container>
          </SimpleBar>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
